import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";

export default function CommonPdfHobbiesSection( { resumeData, translations } ) {
    const { hobbies } = extractResumeDataDocumentSection( resumeData );
    const { isAlcyone } = extractResumeProperties( resumeData );

    const themeColor = isAlcyone ? '#09B4BF' : '#0B86C8';

    const styles = StyleSheet.create( {
        sectionCompetence: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        sectionTitle: {
            fontSize: 12,
            fontWeight: 'bold',
            marginBottom: 2,
            textTransform: 'uppercase',
            color: themeColor,
        },
        titleContainer: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        line: {
            flexGrow: 1,
            height: 1,
            backgroundColor: themeColor,
            marginLeft: 5,
        },
        loisir: {
            fontSize: 8,
            marginRight: 2,
        }
    } );

    return (
        <View style={ { marginTop: 10 } }>
            <View style={ styles.titleContainer }>
                <Text style={ styles.sectionTitle }>
                    { translations.pdf.hobbiesTitle }
                </Text>
                <View style={ styles.line }/>
            </View>
            <View style={ styles.sectionCompetence }>
                <Text style={ styles.loisir }>
                    { hobbies
                        .filter( hobby => hobby.text && hobby.text !== '' )
                        .sort( ( a, b ) => a.order - b.order )
                        .map( hobby => hobby.text )
                        .join( ', ' ) }
                </Text>
            </View>
        </View>
    );
}
